import MacroFiltersModal from './MacroFiltersModal';

export default MacroFiltersModal;
